<template>
  <j-modal :title="title"
           :width="width"
           :visible="visible"
           @ok="debouncedHandleOk"
           @cancel="handleCancel"
           :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
           :destroyOnClose="true"
           cancelText="关闭">

    <product-tag-form ref="realForm"
                      @ok="submitCallback"
                      :disabled="disableSubmit"
                      :appList="appList"></product-tag-form>

  </j-modal>

</template>

<script>
import ProductTagForm from './ProductTagForm'
import { debounce } from 'lodash'; // 引入 lodash 的 debounce 方法
export default {
  name: 'ProductTagModal',
  components: {
    ProductTagForm,
  },
   props: {
    appList: {
      type: Array,
    },
  },
  data() {
    return {
      title: '',
      width: 900,
      visible: false,
      disableSubmit: false,
    }
  },
  methods: {
    add() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add()
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
  created () {
    // 使用 debounce 包装 handleOk 方法
    this.debouncedHandleOk = debounce(this.handleOk, 500); // 500ms 内只触发一次
  }
}
</script>